import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

import Loader from "@/components/layout/Loader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Coproperty',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView, null, {
    default: _withCtx(({Component}) => [
      Component
        ? (_openBlock(), _createBlock(_Suspense, { key: 0 }, {
            fallback: _withCtx(() => [
              _createVNode(Loader)
            ]),
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})